import Highcharts from 'highcharts';
import 'highcharts/modules/stock';
import 'highcharts/highcharts-more';
import 'highcharts/indicators/indicators-all';
import 'highcharts/modules/annotations';
import 'highcharts/modules/exporting';
import 'highcharts/modules/export-data';
import 'highcharts/modules/treemap';
import 'highcharts/modules/heatmap';
import 'highcharts/modules/wordcloud';
import 'highcharts/modules/solid-gauge';
import 'highcharts/modules/funnel';
import 'highcharts/modules/sankey';
import 'highcharts/modules/dependency-wheel';
import 'highcharts/modules/networkgraph';
import 'highcharts/modules/organization';
import 'highcharts/modules/sunburst';
import 'highcharts/modules/venn';
import 'highcharts/modules/timeline';
import 'highcharts/modules/xrange';
import 'highcharts/modules/bullet';
import 'highcharts/modules/variable-pie';
import 'highcharts/modules/item-series';
import 'highcharts/modules/histogram-bellcurve';
import 'highcharts/modules/drilldown';
import 'highcharts/modules/no-data-to-display';
import 'highcharts/modules/accessibility';
import { VIETNAMESE_LOCALE } from './chartTheme';

const globalHC = window._Highcharts;
if (globalHC && globalHC !== Highcharts) {
    Object.keys(globalHC.seriesTypes || {}).forEach(type => {
        if (!Highcharts.seriesTypes[type]) {
            Highcharts.seriesTypes[type] = globalHC.seriesTypes[type];
        }
    });
}
window._Highcharts = Highcharts;

if (!Highcharts.getOptions().lang?.months?.[0]?.includes('Tháng')) {
    Highcharts.setOptions({ lang: VIETNAMESE_LOCALE });
}

export default Highcharts;
